<template>
  <div class="referral">
    <div class="top-referral">
      <div class="box" v-for="(item , index) in data" :key="index">
        <div class="align">
          <inline-svg  :src="require('../../../../assets/icon/panel/' + item.logo)" alt=""/>
          <span class="title">{{ item.title }}</span>
        </div>
        <div class="value">
          <span style="font-weight: bold">{{ $toLocal(item.number,$decimal['TOMAN']) }}</span>
          <span v-if="item.title === 'سود من از دعوت'">تومان</span>
        </div>
      </div>
    </div>
    <div class="bottom-referral">
      <span class="text">دعوت از دوستان از طریق لینک :</span>
      <div class="inputs">
        <label class="my-lable">
          <span v-if="copyLinkShow" class="copy-alert">کپی شد</span>
          <img class="copy" src="../../../../assets/icon/copy.png" alt="" @click="copyLink()">
          <input :disabled="true" :value="inviteLink" type="text" class="public-input">
        </label>
        <span class="span-and">یا</span>
        <label class="my-lable">
          <span v-if="copycode" class="copy-alert">کپی شد</span>
          <img class="copy" src="../../../../assets/icon/copy.png" alt="" @click="copyCode()">
          <input :disabled="true" :value="referral" type="text" class="public-input">
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "the-referral",
  data() {
    return {
      copyLinkShow:false,
      copycode:false,
        referral:'',
      inviteLink:'https://daric.com/register?ref=',
      data: [
        {title: 'تعداد سفارشات من', number: 25, logo: 'orders.svg'},
        {title: 'تعداد سفارشات فعال من', number: 25, logo: 'activeOrder.svg'},
        {title: 'تعداد معاملات من', number: 70, logo: 'numberOfTrade.svg'},
        {title: 'تعداد دعوت ها', number: 25, logo: 'refrral.svg'},
        {title: 'سود من از دعوت', number: 1235348, logo: 'fee.svg'},
      ]
    }
  },
  methods:{
    copyLink(){
      navigator.clipboard.writeText('https://.google.com/')
      this.copyLinkShow=true;
      setTimeout(()=>{this.copyLinkShow=false;},3000)



    },
    copyCode(){
      navigator.clipboard.writeText('123456')
      this.copycode=true;
      setTimeout(()=>{this.copycode=false} ,3000)
    },
     async getRefferalsFromServer(){
   let response;
      const res = await this.$axios.get('/users/invites')
      this.data[0].number = this.state.userInfo.totalTradesAmount
      this.data[2].number = this.state.userInfo.totalTradesAmount
      this.data[3].number = res.baseDTO.countInvitees
      this.data[4].number = res.baseDTO.profit
      this.data[4].number = this.$toLocal(this.data[4].number, this.$decimal['TOMAN'])
      this.inviteLink = `${this.inviteLink}/${res.baseDTO.referralCode}`
      this.referral = res.baseDTO.referralCode
    }
  },
    mounted(){
    this.getRefferalsFromServer()
}
}
</script>

<style lang="scss" scoped>

.align{
  display: flex;
  align-items: center;
  justify-content: center;
}

.referral {
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.top-referral {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;

  .box {
    display: flex;
    white-space: nowrap;
    flex-direction: column;
    gap: 24px;
    justify-content: flex-start;
    flex-grow: 1;
    flex-basis: 100px;
    text-align: right;
    align-items: flex-start;

    &:first-child{
      align-items: flex-start !important;
    }



    .value{
      display: flex;
      flex-direction: row;
      font-size: clamp(14px , 2vw ,16px) !important;
      color: #D7C8C8;
    }

    .title {
      color: #D7C8C8;
      margin-right: 5px;
      font-size: clamp(12px, 0.7vw, 16px);
      font-weight: bold;
    }
  }
}

.bottom-referral {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  column-gap: clamp(20px,3.5vw,60px);
  flex-wrap: wrap;

  .text {
    color: rgba(215, 200, 200, 1);
    font-size: clamp(12px, 2vw, 16px);
    margin-bottom: 10px;
  }

  .inputs {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 20px;
    color: #FBFBFD;
    align-items: center;
    flex-wrap: wrap;
    flex-grow: 1;

    .span-and {
      text-align: center;
    }

    .public-input {
      text-align: left;
    }

    .my-lable {
      position: relative;
      flex-grow: 1;
      flex-basis: 100px;

      .copy-alert{
        font-size: 12px;
        color: #FFFFFF;
        background-color: rgba(22, 24, 28, 0.7);
        padding: 10px;
        border-radius: 5px;
        position: absolute;
        top: -45px;
      }

      .copy {
        position: absolute;
        top: 25%;
        bottom: 25%;
        right: 10px;
        cursor: pointer;
      }
    }

  }
}

@media (max-width: 650px) {
  .span-and {
    display: none;
  }
}
@media (max-width: 550px) {
  .inputs{
    flex-direction: column !important;
    gap: 10px !important;
  }

  .my-lable{
    flex-basis: 0 !important;
  }
}
</style>